var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDistrubuterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 64,
    viewBox: "0 0 54 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5V45.5H45V20.75C42.4789 20.75 40.1569 19.9062 38.2793 18.5H9Z",
    fill: "#7065E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 6.125L27 0.5V5C12.0881 5 0 17.0881 0 32C0 43.556 7.26188 53.411 17.469 57.2641L19.4839 55.5845C9.4905 52.4019 2.25 43.0486 2.25 32C2.25 18.3313 13.3313 7.25 27 7.25V11.75L33.75 6.125Z",
    fill: "#2AD3E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5H13.5V45.5H9V18.5Z",
    fill: "#E7E5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 18.5V25.25L27 23L29.25 25.25V18.5H24.75Z",
    fill: "#FA6450"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 38.75H40.5V41H33.75V38.75Z",
    fill: "#E7E5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 34.25H40.5V36.5H33.75V34.25Z",
    fill: "#E7E5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6967 20.1119C50.6351 23.641 51.75 27.6877 51.75 31.9987C51.75 45.6674 40.6687 56.7487 27 56.7487V52.2487L20.25 57.8737L27 63.4987V58.9987C41.9119 58.9987 54 46.9105 54 31.9987C54 27.3468 52.8075 22.9795 50.7352 19.1602C50.0929 19.5415 49.4122 19.8622 48.6967 20.1119Z",
    fill: "#2AD3E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 18.5C49.9706 18.5 54 14.4706 54 9.5C54 4.52944 49.9706 0.5 45 0.5C40.0294 0.5 36 4.52944 36 9.5C36 14.4706 40.0294 18.5 45 18.5Z",
    fill: "#24D626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 9.5C38.25 4.91113 41.6869 1.13225 46.125 0.577625C45.756 0.5315 45.3814 0.5 45 0.5C40.0297 0.5 36 4.52975 36 9.5C36 14.4703 40.0297 18.5 45 18.5C45.3814 18.5 45.756 18.4685 46.125 18.4224C41.6869 17.8678 38.25 14.0889 38.25 9.5Z",
    fill: "#1EAA96"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.625 7.25L43.875 14L39.375 9.5L41.625 7.25L43.875 9.5L48.375 5L50.625 7.25Z",
    fill: "#F0F0F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrubuterIcon);
export default __webpack_public_path__ + "static/media/distrubuter-icon.42d90c7c29190c12ad473c6b22ca5efb.svg";
export { ForwardRef as ReactComponent };